import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type DisplayImageDialogData = Record<string, never>;

@Component({
    selector: 'app-display-image',
    templateUrl: './display-info-image.component.html',
    styleUrls: ['./display-info-image.component.scss'],
    standalone: false
})
export class DisplayInfoImageComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DisplayImageDialogData) {}

  ngOnInit(): void {}
}
